import Carousel from '../components/Carousel'
import Banner from '../components/Banner'
import { discountVoucherHref, tripDotComHref, apMTradingHref, exchangeHref, irisHref } from '../constants/href';
import { popupsquareImage } from '../assets/images';

function PopupSquareCarousel() {
  const adBannerArray = [
    <Banner key={discountVoucherHref.name} gaPage='Popup Square' name={discountVoucherHref.name} eventHref={discountVoucherHref.href} image={popupsquareImage.discountVoucherPopupsquare}/>
  ]
  
  const shuffledBanner = adBannerArray.sort(() => Math.random() - 0.5);

  return (
    <Carousel gaPage='Popup Square'>
      { shuffledBanner }
      <Banner key={irisHref.name} gaPage='Popup Square' name={irisHref.name} eventHref={irisHref.href} image={popupsquareImage.irisPopupsquare}/>
      <Banner key={apMTradingHref.name} gaPage='Popup Square' name={apMTradingHref.name} eventHref={apMTradingHref.href} image={popupsquareImage.apMTradingPopupsquare}/>
      <Banner key={exchangeHref.name} gaPage='Popup Square' name={exchangeHref.name} eventHref={exchangeHref.href} image={popupsquareImage.exchangePopupsquare}/>
      <Banner key={tripDotComHref.name} gaPage='Popup Square' name={tripDotComHref.name} eventHref={tripDotComHref.href} image={popupsquareImage.tripDotComPopupsquare}/>
    </Carousel>
  )
}

export default PopupSquareCarousel;
